import { render } from "./LabelAdd.vue?vue&type=template&id=6046d7e2&scoped=true"
import script from "./LabelAdd.vue?vue&type=script&lang=js"
export * from "./LabelAdd.vue?vue&type=script&lang=js"

import "./LabelAdd.vue?vue&type=style&index=0&id=6046d7e2&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6046d7e2"]])

export default __exports__